import { hasFlag } from "client/Misc/utils";

export enum SpaceChangeEffect {
	None = 0,
	TileGroupGridRepackingIsRequired = 1 << 0
}

export enum TileGroupChangeEffect {
	None = 0,
	ConsumedSpaceIsChanged = 1 << 0
}

export enum TileGridChangeEffect {
	None = 0,
	HeightIsChanged = 1 << 0
}

export class SpaceReducerContext {
	private _resultEffect: SpaceChangeEffect = SpaceChangeEffect.None;

	public get resultEffect(): SpaceChangeEffect {
		return this._resultEffect;
	}

	public addEffect(effect: SpaceChangeEffect) {
		this._resultEffect |= effect;
	}

	public createGroupContext(): TileGroupReducerContext {
		return new TileGroupReducerContext(this);
	}
}

export class TileGroupReducerContext {
	private readonly _parentContext?: SpaceReducerContext;
	private _groupEffect: TileGroupChangeEffect;

	public get resultEffect(): TileGroupChangeEffect {
		return this._groupEffect;
	}

	constructor(parentContext?: SpaceReducerContext) {
		this._groupEffect = TileGroupChangeEffect.None;
		this._parentContext = parentContext;
	}

	public addEffect(effect: TileGroupChangeEffect): void {
		this._groupEffect |= effect;

		this._parentContext
			?.addEffect(
				this.convertEffect(effect)
			);
	}

	public createGridContext(): TileGridReducerContext {
		return new TileGridReducerContext(this);
	}

	private convertEffect(effect: TileGroupChangeEffect): SpaceChangeEffect {
		let result: SpaceChangeEffect = SpaceChangeEffect.None;

		if (hasFlag(effect, TileGroupChangeEffect.ConsumedSpaceIsChanged)) {
			result |= SpaceChangeEffect.TileGroupGridRepackingIsRequired;
		}

		return result;
	}
}

export class TileGridReducerContext {
	private readonly _parentContext?: TileGroupReducerContext;
	private _gridEffect: TileGridChangeEffect;

	public get resultEffect(): TileGridChangeEffect {
		return this._gridEffect;
	}

	constructor(parentContext?: TileGroupReducerContext) {
		this._parentContext = parentContext;
		this._gridEffect = TileGridChangeEffect.None;
	}

	public addEffect(effect: TileGridChangeEffect): void {
		this._gridEffect |= effect;

		this._parentContext
			?.addEffect(
				this.convertEffect(effect)
			);
	}

	private convertEffect(effect: TileGridChangeEffect): TileGroupChangeEffect {
		let result: TileGroupChangeEffect = TileGroupChangeEffect.None;

		if (hasFlag(effect, TileGridChangeEffect.HeightIsChanged)) {
			result |= TileGroupChangeEffect.ConsumedSpaceIsChanged;
		}

		return result;
	}
}